import CryptoJS from "crypto-js";
import {Server} from '../Server/Server'
function UserManager (){

}
UserManager.prototype={
    key:"08596@qq.com2018",
    password:"",
    currentUserId:"",
    checkLoginCallback:null,
    server:new Server(),

    //设置cookie
    setCookie:function(portId, psw, exdays) {
      console.log(portId);
      console.log(psw);
        // Encrypt，加密账号密码
        var cipherUserId = CryptoJS.AES.encrypt(portId+'',this.key).toString();
        var cipherPsw = CryptoJS.AES.encrypt(psw+'', this.key).toString();
        var exdate = new Date(); //获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
        //字符串拼接cookie，为什么这里用了==，因为加密后的字符串也有个=号，影响下面getcookie的字符串切割，你也可以使用更炫酷的符号。
        window.document.cookie ="currentUserId" +"==" +cipherUserId +";path=/;expires=" +exdate.toGMTString();
        window.document.cookie ="password" +"==" +cipherPsw +";path=/;expires=" +exdate.toGMTString();
      },
      //读取cookie
      getCookie: function() {
        if (window.document.cookie.length > 0) {
          var arr = window.document.cookie.split(";"); //这里显示的格式请根据自己的代码更改
          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split("=="); //根据==切割
            //判断查找相对应的值
            if (arr2[0].trim() =="currentUserId") {
              // Decrypt，将解密后的内容赋值给账号
              var bytes = CryptoJS.AES.decrypt(arr2[1], this.key);
              this.currentUserId = bytes.toString(CryptoJS.enc.Utf8)-0;
            } else if (arr2[0].trim() == "password") {
              // Decrypt，将解密后的内容赋值给密码
              var bytes = CryptoJS.AES.decrypt(arr2[1], this.key);
              this.password = bytes.toString(CryptoJS.enc.Utf8);
            }
          }
        }
      },
      //清除cookie
      clearCookie: function() {
        this.setCookie("", "", -1); 
      },
      login:function(){
      },
      checkIsLogined:function(callBack){
        // this.clearCookie();
        window.document.cookie.clea
          this.checkLoginCallback=callBack;
          if(window.document.cookie.length>0&&window.document.cookie.indexOf("currentUserId")!=-1){
              this.getCookie();
              this.server.userInfo(this.currentUserId,this.password,callBack);
          }else{
            callBack({"msg":"没有登过","state":"error"});
          }
      },
}
export{
    UserManager
}